import { createTheme } from '@mui/material/styles';
import { primaryColor, primaryColorAdmin, secondaryColor } from '../../tailwind.config.ts';

const rootElement = document.getElementById('root');

const components = {
  MuiPopover: {
    defaultProps: {
      container: rootElement,
    },
  },
  MuiPopper: {
    defaultProps: {
      container: rootElement,
    },
  },
  MuiDialog: {
    defaultProps: {
      container: rootElement,
    },
  },
  MuiModal: {
    defaultProps: {
      container: rootElement,
    },
  },
  MuiContainer: {
    styleOverrides: {
      maxWidthLg: {
        width: '1143px',
      },
    },
  },
};

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
  },
  components,
});

const adminTheme = createTheme({
  palette: {
    primary: {
      main: primaryColorAdmin,
    },
    secondary: {
      main: secondaryColor,
    },
  },
  components,
});

export default {
  default: defaultTheme,
  admin: adminTheme,
};
